import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaFileInvoiceDollar } from "react-icons/fa";
import styles from "../../master/academicConfiguration/Academiclist.module.css";
import { CustomTab } from "../../../../components";
import AllFeesTransactionsReport from "./AllFeesTransactionsReport";
import RegularTransaction from "./RegularTransaction";
import AdmissionTransaction from "./AdmissionTransaction";

const FeesTransactionsReportTabs = () => {
  //   const navigate = useNavigate();
  const { translations } = useSelector((state) => state.language);
  const labels = translations?.labels || {};
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const tabs = [
    {
      label: labels.all || "All",
      content: <AllFeesTransactionsReport />,
    },
    {
      label: labels.regularTransaction || "Regular Transaction",
      content: <RegularTransaction />,
    },
    {
      label: labels.admissionTransaction || "Admission Transaction",
      content: <AdmissionTransaction />,
    },
  ];

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerIcon}>
          <FaFileInvoiceDollar />
        </div>
        <h1 className={styles.headerTitle}>
          {labels.allFeesTransactionsReport || "All Fees Transactions Report"}
        </h1>
      </div>

      <CustomTab
        tabs={tabs}
        defaultActiveTab={0}
        onTabChange={handleTabChange}
      />
    </div>
  );
};

export default FeesTransactionsReportTabs;
